import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
// import { roleColumns } from './_columns'
import { useNavigate } from 'react-router-dom'
import { roleColumns } from './_columnsC'
const UsersList = () => {
  const navigate = useNavigate()
  const { itemIdForUpdate } = useListView()
  return (
    <KTCard>
      {/* <div style={{ padding: '20px 24px', }}>
        <button
          onClick={() => navigate('/apps/makting/engagement/add-engagement')}
          className='btn'
          style={{ background: "#ed6e43", color: "white" }}
        >
          + Add New
        </button>
      </div> */}
      {/* <UsersListHeader placeholder='Search Sponsor'/> */}
      <UsersTable columnProps={roleColumns} />
      <UserEditModal formName='ShowcaseForm' />
    </KTCard>
  )
}

const EngagementWrapper = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'engagement' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { EngagementWrapper }
